import {
  Box,
  HStack,
  Stack,
  Text,
  VStack,
  Image,
  // IconButton,
  Button,
  Skeleton,
  // Tag,
  // TagLeftIcon,
  // TagLabel,
  useDisclosure,
  Alert,
  AlertIcon,
  Tag,
  TagLeftIcon,
  TagLabel,
} from "@chakra-ui/react";
// import { ChevronRightIcon } from "@chakra-ui/icons";

import ChipImage from "assets/png/chip-image.png";
import BitmamaLogo from "assets/svg/bitmama-logo-white.png";
import CardOrnament from "assets/svg/card-ornament.svg";
import { ReactComponent as MasterCardIcon } from "assets/svg/mastercard-logo.svg";

// import CustomButton from "components/Button/Button";
import Confirmation from "components/Modals/p2p/Confirmation";
// import { BsShieldLockFill } from "react-icons/bs";

// import map from "assets/png/virtual-card-bg.png";

// import chunk from "lodash/chunk";
import toUpper from "lodash/toUpper";
import { useMemo } from "react";
import { BsShieldLockFill } from "react-icons/bs";
// import formatter from "util/formatter";

export const getCardScheme = (type) => {
  const map = {
    tier1: "whitesmoke",
    tier2: "red",
    tier3: "blue",
    tier4: "green",
    tier5: "black",
  };

  return map[type ?? "tier1"];
};

const Card = ({
  colorScheme,
  limit,
  validity,
  number,
  name,
  balance,
  currency,
  showBalance,
  onClick,
  isDeclined,
  isLoading,
  isUnfreezing,
  onUnfreeze,
  status,
  hasMessage,
  ...xprops
}) => {
  const { isOpen, onClose } = useDisclosure();

  const getColorScheme = () => {
    const map = {
      white: {
        foreground: "black",
        background: "white",
        borderColor: "#8688942f",
      },
      whitesmoke: {
        foreground: "black",
        background: "whitesmoke",
        borderColor: "#8688942f",
      },
      red: {
        foreground: "white",
        background:
          "linear-gradient(156.39deg, #DA4040 6.76%, #9E2929 88.75%), #DA4040",
        borderColor: "transparent",
      },
      blue: {
        foreground: "white",
        background:
          "linear-gradient(156.39deg, #3D90FF 6.76%, #1D70E1 88.75%), #1D70E1",
        borderColor: "transparent",
      },
      green: {
        foreground: "white",
        background:
          "linear-gradient(156.39deg, #66C961 6.76%, #3F943B 88.75%), #79D775",
        borderColor: "transparent",
      },
      black: {
        foreground: "white",
        background:
          "linear-gradient(156.39deg, #282930 6.76%, #16171C 88.75%), #282930;",
        borderColor: "transparent",
      },
    };

    return map[colorScheme ?? "whitesmoke"];
  };

  const statusInfo = useMemo(() => {
    const map = {
      approved: "Card has been approved for dispatch",
      pending: "Card is being processed",
    };

    return map[status ?? "pending"];
  }, [status]);

  // const handleClick = () => {
  //   onClick && onClick({ limit, colorScheme });
  // };

  const handleUnfreeze = () => {
    onClose();
    onUnfreeze && onUnfreeze();
  };

  return (
    <Box
      m="0 !important"
      w={["100%", "100%", "340px"]}
      maxW="340px"
      {...xprops}
    >
      <Button
        d="flex"
        flexDir="column"
        justifyContent="space-between"
        w={["100%", "100%", "340px"]}
        h={["216px"]}
        // border="1px solid transparent"
        // borderColor={`${getColorScheme()?.borderColor} !important`}
        borderRadius="16px"
        p="14px 18px"
        // bgImage="url('/assets/png/virtual-card-bg.png')"
        pos="relative"
        overflow="hidden"
        bg={getColorScheme()?.background}
        variant="unstyled"
        _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
        // onClick={isFrozen ? undefined : handleClick}
        // cursor={isFrozen ? "auto" : "pointer"}
      >
        {isDeclined && (
          <Box
            pos="absolute"
            w="100%"
            h="100%"
            bg="#000000d1"
            zIndex="9"
            top="0"
            left="0"
          >
            <VStack
              h="100%"
              justifyContent="flex-end"
              alignItems="center"
              pos="relative"
            >
              <Tag
                size="md"
                variant="subtle"
                colorScheme="red"
                pos="absolute"
                right="20px"
                top="20px"
              >
                <TagLeftIcon boxSize="12px" as={BsShieldLockFill} />
                <TagLabel fontSize="12px" textTransform="uppercase">
                  Declined
                </TagLabel>
              </Tag>
            </VStack>
          </Box>
        )}

        {status === "issued" && (
          <Box
            pos="absolute"
            w="100%"
            h="100%"
            bg="#000000d1"
            zIndex="9"
            top="0"
            left="0"
          >
            <VStack
              h="100%"
              justifyContent="flex-end"
              alignItems="center"
              pos="relative"
            >
              <Tag
                size="md"
                variant="subtle"
                colorScheme="green"
                pos="absolute"
                right="20px"
                top="20px"
              >
                <TagLeftIcon boxSize="12px" as={BsShieldLockFill} />
                <TagLabel fontSize="12px" textTransform="uppercase">
                  Issued
                </TagLabel>
              </Tag>
            </VStack>
          </Box>
        )}

        <Image
          pointerEvents="none"
          src={CardOrnament}
          pos="absolute"
          bottom="0"
          left="0"
        />
        <HStack
          w="100%"
          alignItems={showBalance ? "flex-start" : "flex-start"}
          justifyContent="space-between"
          pos="relative"
          zIndex="2"
          // mt="-50px"
        >
          <Skeleton isLoaded={!isLoading}>
            <Image boxSize="38px" alt="" src={BitmamaLogo} />
          </Skeleton>
        </HStack>

        <HStack
          mt="14px"
          w="100%"
          pos="relative"
          zIndex="2"
          color={getColorScheme()?.foreground}
        >
          <HStack>
            <Image w="40px" src={ChipImage} alt="" />
          </HStack>
        </HStack>

        <Stack
          w="100%"
          pos="relative"
          zIndex="2"
          color={getColorScheme()?.foreground}
        >
          <HStack
            // alignSelf="flex-end"
            justifyContent="space-between"
            mt="24px !important"
            textShadow="0px 0px 1px rgba(0, 0, 0, 0.5)"
          >
            <Skeleton
              mt="0 !important"
              isLoaded={!isLoading}
              h={isLoading ? "12px" : "fit-content"}
            >
              <Text fontSize="10px" fontWeight="500">
                {toUpper(name ?? "YOUR NAME HERE")}
              </Text>{" "}
            </Skeleton>

            <HStack>
              <Box as={MasterCardIcon} />
            </HStack>
          </HStack>
        </Stack>
      </Button>

      {hasMessage && !isDeclined && (
        <Stack py="16px">
          <Alert status="info" borderRadius="10px">
            <AlertIcon />
            {statusInfo}
          </Alert>
        </Stack>
      )}

      <Confirmation
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={handleUnfreeze}
        title="Confirm Card Unfreeze"
      >
        <VStack>
          <Text>Are you sure you want to unfreeze this card?</Text>
        </VStack>
      </Confirmation>
    </Box>
  );
};

export default Card;
